export const paginationSizes = [10, 25, 50]
